export * from "./MainBannerAdvantages";
export * from "./MainBannerAdvantages.types";
